import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import { APP_DEFAULT_PATH } from 'config';
import useAuthEntra from 'hooks/useAuthPharo';
import { getCurrentAppType } from 'utils/dynamicConfig';

// types
import { GuardProps } from 'types/auth';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }: GuardProps) {
  const { isAuthenticated } = useAuthEntra();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      const appType = getCurrentAppType();
      const defaultPath = appType.includes('ops') ? '/ops-tools' : '/order-create';
      
      const finalPath = location?.state?.from ? location?.state?.from : defaultPath;
      
      // Preserve URL parameters when navigating
      const urlParams = new URLSearchParams(window.location.search);
      const targetPath = urlParams.toString() ? `${finalPath}?${urlParams.toString()}` : finalPath;
      
      navigate(targetPath, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isAuthenticated, navigate, location]);

  return children;
}
